module.exports = __webpack_public_path__ + "img/american_express.2c451fde.svg";